(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchasePresentItem', PurchasePresentItem);

    PurchasePresentItem.$inject = ['$resource'];

    function PurchasePresentItem ($resource) {
        var resourceUrl =  'api/purchase-present-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
